module.exports = __webpack_public_path__ + "../front_assets/img/spanish.aaec6aa0.png";